var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#BDF3C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9998 53.7505L21.8604 39.8598C21.6563 39.6511 21.4956 39.404 21.3876 39.1327C21.2797 38.8614 21.2267 38.5714 21.2318 38.2795C21.2368 37.9876 21.2997 37.6995 21.4169 37.4321C21.5341 37.1647 21.7032 36.9232 21.9145 36.7217C22.1257 36.5201 22.3748 36.3625 22.6474 36.258C22.92 36.1535 23.2107 36.1041 23.5025 36.1128C23.7944 36.1214 24.0816 36.188 24.3475 36.3085C24.6134 36.429 24.8528 36.6011 25.0517 36.8148L34.9998 47.5005L54.9648 26.8711C55.167 26.6637 55.4081 26.4981 55.6742 26.3839C55.9404 26.2696 56.2265 26.2089 56.5161 26.2053C56.8057 26.2016 57.0933 26.255 57.3623 26.3624C57.6313 26.4698 57.8765 26.6292 58.0839 26.8314C58.2913 27.0336 58.4568 27.2747 58.5711 27.5408C58.6853 27.807 58.746 28.0931 58.7497 28.3827C58.7534 28.6723 58.7 28.9599 58.5925 29.2289C58.4851 29.4978 58.3258 29.743 58.1236 29.9505L34.9998 53.7505Z",
    fill: "#0DAA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8a697106cb66289595cb5f4145162afd.svg";
export { ForwardRef as ReactComponent };